module.exports = __webpack_public_path__ + "img/meeting-empty.279af8da.png";